// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2IFIK","approved":"Status_approved__1V6cF","rejected":"Status_rejected__1vkOF","expired":"Status_expired__228oa","label":"Status_label__39nXP"};